import { useLoading } from "@/contexts/LoadingContext";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { cancelSubscription, fetchUserDetails } from "../services/admin-services";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import ConfirmDialog from "@/features/admin/users-list/cancelsubscription-dialog";
import toastService from "@/services/toastService";
import { SUBSCRIPTIONS_USER_STATUS } from "@/utils/constant";

interface StripeRecurrence {
  interval: "day" | "week" | "month" | "year";
  interval_count: number;
}
interface StripeProduct {
  id?: string;
  name?: string;
}
interface StripePrice {
  id?: string;
  recurrence?: StripeRecurrence;
  unit_amount?: number;
  currency?: string;
  product?: StripeProduct;
}

interface UserData {
  _id?: string;
  email?: string;
  status?: number;
  companyName?: string;
  fullName?: string;
  phoneNumber?: string;
  countryName?: string;
  stripe_product?: string;
  stripe_price?: StripePrice;
  current_period_start?: number;
  current_period_end?: number;
  isSubscribed?: boolean;
  isSubUser?: boolean;
  createdBy?: CreatedBy;
}
interface CreatedBy {
  _id?: string;
  email?: string;
  fullName?: string;
}

const UserDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [user, setUser] = useState<UserData | null>(null);
  const [_,setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setLoading } = useLoading();



    const handleConfirm = async() => {
    // Perform cancel subscription logic here
    try {
      setIsLoading(true);
      const response = await cancelSubscription(user?.email);
      if (response?.statusCode === 200) {
        toastService.success("Subscription cancelled successfully");
        navigate("/admin/dashboard/all-users");
      }
      
    } finally {
      setIsLoading(false);
      setIsDialogOpen(false);

    }
    console.log("Subscription cancelled");
    setIsDialogOpen(false);
  };


  const getUserDetails = async () => {
      if (!id) return;

      setLoading(true);
      try {
        const userData = await fetchUserDetails(id);
        console.log(userData.data, "UserData");

        setUser(userData.data);
      } catch (error) {
        console.error("Error fetching user details:", error);
        // Handle error (e.g., show toast notification)
      } finally {
        setLoading(false);
      }
    };
  useEffect(() => {
    getUserDetails();
  }, [id]);

  const [isDialogOpen, setIsDialogOpen] = useState(false);




  const formatEpochToPrettyDateTime = (epochMs: number): string => {
    const date = new Date(epochMs);
  
    const day = date.toLocaleDateString("en-US", { weekday: "long" }); // e.g., Thursday
    const datePart = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    }); // e.g., Jul 10, 2025
    // const time = date.toLocaleTimeString("en-US", {
    //   hour: "2-digit",
    //   minute: "2-digit",
    //   hour12: true,
    // }); // e.g., 11:37 PM
  
    return `${day}, ${datePart}`;
  };
  

  return (
    <div className=" mt-8">
      <div className="w-[100%] 2xl:w-[96%] mx-auto  pl-4 2xl:pl-0 flex justify-between items-center">
        {/* Back Button */}
        <div className="flex gap-x-3 ">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="secondary"
                  className="flex items-center"
                  size="icon"
                  onClick={() => history.back()}
                >
                  <ChevronLeft />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                <p>Go Back</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>

          {user?.isSubscribed ? (
            <span className="inline-flex items-center  font-outfit font-medium text-[24px]">
              {/* <span className="w-2 h-2 bg-green-500 rounded-ful"></span> */}
              Subscribed User Details
            </span>
          ):<span className="inline-flex items-center  font-outfit font-medium text-[24px]">
          {/* <span className="w-2 h-2 bg-green-500 rounded-ful"></span> */}
          User Details
        </span>}
        </div>

        {/* Subscription Chip */}
        <div>
          {user?.status ===  SUBSCRIPTIONS_USER_STATUS.ACTIVE ? (
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-green-100 text-green-800 font-outfit font-medium text-sm">
              <span className="w-2 h-2 bg-green-500 rounded-full"></span>
              Subscribed User
            </span>
          ) : (
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-100 text-red-800 font-outfit font-medium text-sm">
              <span className="w-2 h-2 bg-red-500 rounded-full"></span>
              Unsubscribed User
            </span>
          )}
        </div>
      </div>

      <div className="mt-4 border-t border-[#e4e4e4]" />

      <div className=" w-[94%] 2xl:w-[97%] mx-auto pl-10 2xl:pl-2 mt-10  min-h-screen">
        {/* Cards Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
            <div>
              <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                Name
              </h2>
              <p className="font-outfit font-medium text-[20px] text-[#181818] flex items-center gap-2">
                {user?.fullName ? user.fullName : "-"}
                {user?.isSubUser === true && (
                  <span className="text-orange-600 text-[14px] font-normal">
                    (Sub User)
                  </span>
                )}
              </p>
            </div>
          </div>

          <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
            <div>
              <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                Email
              </h2>
              <p className="font-outfit font-medium text-[20px] text-[#181818]">
                {user?.email ? user?.email : "--"}
              </p>
            </div>
          </div>

          <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
            <div>
              <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                Phone
              </h2>
              <p className="font-outfit font-medium text-[20px] text-[#181818]">
                {user?.phoneNumber ? user?.phoneNumber : "-"}
              </p>
            </div>
          </div>

          <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
            <div>
              <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                Company
              </h2>
              <p className="font-outfit font-medium text-[20px] text-[#181818]">
                {user?.companyName ? user?.companyName : "-"}
              </p>
            </div>
          </div>
          {user?.stripe_product && (
            <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
              <div>
                <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                  Stripe Product ID
                </h2>
                <p className="font-outfit font-medium text-[20px] text-[#181818]">
                  {user?.stripe_product ? user?.stripe_product : "-"}
                </p>
              </div>
            </div>
          )}
          {user?.stripe_price && (
            <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
              <div>
                <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                  Stripe Price
                </h2>
                <p className="font-outfit font-medium text-[20px] text-[#181818]">
                  ${user?.stripe_price?.unit_amount}/
                  {user?.stripe_price?.recurrence?.interval}
                </p>
              </div>
            </div>
          )}

          <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
            <div>
              <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                Country
              </h2>
              <p className="font-outfit font-medium text-[20px] text-[#181818]">
                {user?.countryName ? user?.countryName : "-"}
              </p>
            </div>
          </div>

          <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
            <div>
              <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                Subscription Start Date
              </h2>
              <p className="font-outfit font-medium text-[20px] text-[#181818]">
                {user?.current_period_start ? formatEpochToPrettyDateTime(user.current_period_start) : "--"}
              </p>
            </div>
          </div>


          <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
            <div>
              <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                Subscription End Date
              </h2>
              <p className="font-outfit font-medium text-[20px] text-[#181818]">
              {user?.current_period_end ? formatEpochToPrettyDateTime(user.current_period_end) : "--"}
              </p>
            </div>
          </div>


          {user?.createdBy && 
          <div className="w-full h-[80px] bg-white rounded-[4px] border border-[#e4e4e4] flex items-center p-[12px] mb-[16px]">
           
            <Link to ={`/admin/dashboard/users/${user?.createdBy?._id}`}>
            <div>
              <h2 className="font-outfit font-normal text-[16px] text-[#828282]">
                Created By
              </h2>
              <p className="font-outfit font-medium text-[20px] text-[#181818]">
                {user?.createdBy?.fullName && user?.createdBy?.email
                  ? `${user.createdBy.fullName} (${user.createdBy.email})`
                  : "-"}
              </p>
            </div>
            </Link>

          </div>
}

        </div>
        {user?.stripe_product && user.stripe_price && (
          <div className="mt-3">
            <Button
              size="sm"
              className="bg-charcoal text-white rounded-md px-4"
              onClick={() => setIsDialogOpen(true)}
            >
              Cancel Subscription
            </Button>

            {/* Confirm Dialog */}
            <ConfirmDialog
              open={isDialogOpen}
              onOpenChange={setIsDialogOpen}
              onConfirm={handleConfirm}
              title="Cancel Subscription"
              description="You are about to cancel this user from your subscription plan. Are you sure you want to proceed?"
              confirmText="Yes, Remove"
              cancelText="Cancel"
              email={user?.email}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDetails;
